export default "__VITE_PUBLIC_ASSET__26575a11__"